import React from 'react';
import Utils from './Utils';
import styled from 'styled-components';
import PageWrapper from './PageWrapper';

import { EmailSymbol, SlackLogo, PayPalButton, Pay, Pal, PaypalIcon, TipsBox, InformationItem, BigFigure, PrettyButton, FlexGrowBox, ProfileHeader, ProfileWrapper, ColumnProfileWrapper, SessionTextArea } from './Components'
import { Badge, MaestroBadge, MegaMaestroBadge, InfluencerBadge, XpertBadge, EnthusiastBadge, RookieBadge, ProvisionalBadge, RejectedBadge, Emoji, } from './Components'

const ProgressWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
`;

const ProgressBar = styled.div`
  height: 20px;
  border-radius: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #e6e6e6;
`;

const MaestroProgressBarFill = styled(ProgressBar)`
  background-color: #e74c3c;
  transition: width 1s ease-out;
`;

const MegaMaestroProgressBarFill = styled(ProgressBar)`
  background-color: #800000;
  transition: width 1s ease-out;
`;

const InfluencerProgressBarFill = styled(ProgressBar)`
  background-color: #ECC100;
  transition: width 1s ease-out;
`;

const XpertProgressBarFill = styled(ProgressBar)`
  background-color: #64B6D8;
  transition: width 1s ease-out;
`;

const EnthusiastProgressBarFill = styled(ProgressBar)`
  background-color: #1CA79D;
  transition: width 1s ease-out;
`;

const RookieProgressBarFill = styled(ProgressBar)`
  background-color: #9b59b6;
  transition: width 1s ease-out;
`;

const ProfileButton = styled.a`
  display: flex;
  width: fit-content;
  justify-content: center;
  font-family: 'Inter';
  // font-size: 14px;
  font-style: normal;
  font-weight: 500; 
  text-decoration: none;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  background-color: #f8f8f8;
  margin: 25px auto 0 auto;
  ${({ accentColor }) => accentColor && 
    `border: 2px solid ${accentColor}; 
    color: ${accentColor};`
  }
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    color: #fff;
    ${({ accentColor }) => accentColor && 
      `background-color: ${accentColor};`
    }
  }
`;

const borderColors = {
  Maestro: '#e74c3c',
  Influencer: '#ECC100',
  Xpert: '#64B6D8',
  Enthusiast: '#1CA79D',
  Rookie: '#9b59b6',
  Provisional: '#4F4F4F',
  Rejected: '#4F4F4F',
};

class ProfileScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(this.props.user_dict.replaceAll("&#39;", "\'").replaceAll("&#34;", "\"")),
      actorProgress: JSON.parse(this.props.actor_progress.replaceAll("&#39;", "\'").replaceAll("&#34;", "\"")),
      slackProgress: JSON.parse(this.props.slack_progress.replaceAll("&#39;", "\'").replaceAll("&#34;", "\"")),
      score_actor: 0,
      score_slack: 0,
      isEditingAddress: false,
      isPaypalAuthenticated: Boolean(parseInt(this.props.is_paypal_authenticated)),
      slackUserId: '',
      address: '',
      actorNumAcceptedFill: 0,
      slackNumAcceptedFill: 0,
      actorPercentAcceptedFill: 0,
      slackPercentAcceptedFill: 0,
      paypal_button_context: '', 
      reinviteSlackMessage: '',
      actorNextTask: '',
      slackNextTask: '',
    }
    this.handleSaveAddress = this.handleSaveAddress.bind(this);
    this.handleClickPaypalButton = this.handleClickPaypalButton.bind(this);
    this.handleUpdateProvisionalTier = this.handleUpdateProvisionalTier.bind(this);
  }

  componentDidMount() {
    const {actorProgress, slackProgress} = this.state;
    setTimeout(() => {
      this.setState({ actorNumAcceptedFill: actorProgress["ratio_total_accept"] });
      this.setState({ slackNumAcceptedFill: slackProgress["ratio_total_accept"] });
      this.setState({ actorPercentAcceptedFill: parseInt(this.props.mean_recent_performance_actor * 100) });
      this.setState({ slackPercentAcceptedFill: parseInt(this.props.mean_recent_performance_slack * 100) });
      this.setState({ score_slack: this.props.score_slack });
      this.setState({ score_actor: this.props.score_actor });
    }, 1000);
  }
  
  handleSaveAddress(e) {
    e.preventDefault();
    e.stopPropagation();

    // Escape JSON
    let sanitizedAddress = JSON.stringify(this.state.address);
    // Remove the leading and trailing double quotes
    sanitizedAddress = sanitizedAddress.slice(1, -1);

    let data = new FormData();
    data.append("address", sanitizedAddress);

    Utils.apiPost("/profile/me", data)
    .then(() => {window.location.reload(true);})
  };

  handleEmailInvite(e) {
    e.preventDefault();
    e.stopPropagation();

    let data = new FormData();
    data.append("email", this.state.user['email'])
    Utils.apiPost("/profile/invite", data)
    .then((response) => {
      this.setState({reinviteSlackMessage: response.data['message']})
    })
  };

  handleClickPaypalButton() {
    // This should redirect user to paypalButtonUrl ...
    Utils.apiGet('/profile/paypal_button_context').then((result) => {
      let paypal_button_context = result.data
      const baseUrl = result.data.login_page;
      // const baseUrl = "https://www.paypal.com/connect?flowEntry=lg&newUI=Y&";
      const paypalButtonParams = new URLSearchParams(paypal_button_context.query_params);
      const paypalButtonUrl=baseUrl + '?' + paypalButtonParams;
      window.location.href = paypalButtonUrl;
    });
  };

  handleUpdateProvisionalTier(e, source) {
    e.preventDefault();
    e.stopPropagation();
    Utils.apiPost(`/profile/update_provisional_tier/${source}`)
    .then((response) => {
      if (response.data["message"] === 'Updated!') {
        window.location.reload(true);
      }
      else {
        {(source === 'actor') && this.setState({actorNextTask: response.data['message']})}
        {(source === 'slack') && this.setState({slackNextTask: response.data['message']})}
      }
    });
  }

  renderProvisionalActorPerformance() {
    const accentColor = borderColors['Provisional'];
    return (
      <ProgressWrapper>
      <TipsBox>
        <li>Connect <b>PayPal</b>.</li>
        <br/>
        <li>Complete training <a href="/actor">here</a>.</li>
        <br/>
        <li>Learn about the full onboarding process <a href="/faq">here</a>.</li>
      </TipsBox>
      <div>
        <ProfileButton 
          accentColor={accentColor}
          onClick={(e) => this.handleUpdateProvisionalTier(e, 'actor')}
        >
          Unlock Actor Tasks
        </ProfileButton>
        <InformationItem>{this.state.actorNextTask}</InformationItem>
      </div>
      </ProgressWrapper>
      );
  }
  
  renderProvisionalSlackPerformance() {
    const accentColor = borderColors['Provisional'];
    return (
      <ProgressWrapper>
      <TipsBox>
        <li>Connect <b>PayPal</b>.</li>
        <br/>
        <li>Join MixerLab Slack — invitation in your email.</li>
        <br/>
        <li>Complete training in MixerLab Slack #Training channel.</li>
        <br/>
        <li>Learn about the full onboarding process <a href="/faq">here</a>.</li>
      </TipsBox>
      <div>
        <ProfileButton
          accentColor={accentColor} 
          onClick={(e) => this.handleUpdateProvisionalTier(e, 'slack')}
        >
          Unlock Slack Tasks
        </ProfileButton>
        <InformationItem>{this.state.slackNextTask}</InformationItem>
      </div>
      </ProgressWrapper>
      );
  }
  
  renderBadge(badgeType) {
    let BadgeComponent;
    let emoji;
    
    if (badgeType === 'MegaMaestro') {
      BadgeComponent = MegaMaestroBadge;
      emoji = '😈';
    } else if (badgeType === 'Maestro') {
      BadgeComponent = MaestroBadge;
      emoji = '😎';
    } else if (badgeType === 'Influencer') {
      BadgeComponent = InfluencerBadge;
      emoji = '🫡';
    } else if (badgeType === 'Xpert') {
      BadgeComponent = XpertBadge;
      emoji = '🧐';
    } else if (badgeType === 'Enthusiast') {
      BadgeComponent = EnthusiastBadge;
      emoji = '🤩';
    } else if (badgeType === 'Rookie') {
      BadgeComponent = RookieBadge;
      emoji = '😀';
    } else if (badgeType === 'Provisional') {
      BadgeComponent = ProvisionalBadge;
      emoji = '😴';
    } else if (badgeType === 'Rejected') {
      BadgeComponent = RejectedBadge;
      emoji = '😥';
    } 
    return (
      <BadgeComponent>
        <Emoji>{emoji}</Emoji> {badgeType}
      </BadgeComponent>
    );
  }

  renderProgress(badgeType, currTotalAccept, source) {
    const {actorProgress, slackProgress} = this.state;
    let ProgressBarFill;
    let nextBadgeType;
    let deltaTotalAccept;
    let nextMeanRecentPerformance;
    if (badgeType === 'Rookie') {
      ProgressBarFill = RookieProgressBarFill;
    } else if (badgeType === 'Enthusiast') {
      ProgressBarFill = EnthusiastProgressBarFill;
    } else if (badgeType === 'Xpert') {
      ProgressBarFill = XpertProgressBarFill;
    } else if (badgeType === 'Influencer') {
      ProgressBarFill = InfluencerProgressBarFill;
    } else if (badgeType === 'Maestro') {
      ProgressBarFill = MaestroProgressBarFill;
    }
    if (source === 'actor') {
      nextBadgeType = actorProgress["next_tier"];
      deltaTotalAccept = actorProgress["delta_total_accept"];
      nextMeanRecentPerformance = actorProgress["next_mean_recent_performance"];
    } else if (source === 'slack') {
      nextBadgeType = slackProgress["next_tier"];
      deltaTotalAccept = slackProgress["delta_total_accept"];
      nextMeanRecentPerformance = slackProgress["next_mean_recent_performance"];
    }
    return (
      <ProgressWrapper>
        <BigFigure>{currTotalAccept}</BigFigure>
        <InformationItem>Accepted Work</InformationItem>
        <ProgressBar> 
          {(source === 'actor') && <ProgressBarFill style={{width: `${this.state.actorNumAcceptedFill}%`}}/>}
          {(source === 'slack') && <ProgressBarFill style={{width: `${this.state.slackNumAcceptedFill}%`}}/>}
        </ProgressBar>
        <InformationItem>{deltaTotalAccept} more accepted work to {nextBadgeType}</InformationItem>
        {(source === 'actor') && <BigFigure style={{ marginTop: '30px' }}>{this.state.actorPercentAcceptedFill}%</BigFigure>}
        {(source === 'slack') && <BigFigure style={{ marginTop: '30px' }}>{this.state.slackPercentAcceptedFill}%</BigFigure>}
        <InformationItem>Average Task Acceptance</InformationItem>
        <ProgressBar> 
          {(source === 'actor') && <ProgressBarFill style={{width: `${this.state.actorPercentAcceptedFill}%`}}/>}
          {(source === 'slack') && <ProgressBarFill style={{width: `${this.state.slackPercentAcceptedFill}%`}}/>}
        </ProgressBar>
        <InformationItem>{parseInt(nextMeanRecentPerformance * 100)}% or more acceptance for {nextBadgeType}</InformationItem>
      </ProgressWrapper>
    );
  }

  renderBasicInformation(user) {
    const username = user['username'];
    const email = user['email'];
    const phone_number = user['phone_number'];
    const slack_user_id = user['slack_user_id'];
    const address = user['address'];
    const reinviteSlackMessage = this.state.reinviteSlackMessage;
    return (
      <FlexGrowBox style={{ marginTop: "0" }}>
        <ProfileHeader>Basic Information</ProfileHeader>
        <InformationItem>👤 {username}</InformationItem>
        <InformationItem><EmailSymbol/> {email}</InformationItem>
        <InformationItem>📞 {phone_number}</InformationItem>
        {slack_user_id && <InformationItem><SlackLogo /> {slack_user_id}</InformationItem>}
        {(!slack_user_id) && 
        <TipsBox>
          <InformationItem>
            Join the MixerLab Slack! <br />Please check your email for instructions to join. 
          </InformationItem>
            {<PrettyButton onClick={e => {this.handleEmailInvite(e)}}>Resend Invite Email</PrettyButton>}
            {reinviteSlackMessage && <div>{reinviteSlackMessage}</div>}
        </TipsBox>
        }
        {address && 
        <InformationItem> 🏠
          <SessionTextArea 
            style = { {height: '50px'} }
            placeholder = { address}
            disabled = {!this.state.isEditingAddress}
            onChange={(event) => {this.setState({ address: event.target.value })}}
          />
          {(!this.state.isEditingAddress) && <PrettyButton onClick={() => {this.setState({ isEditingAddress: true })}}>Edit</PrettyButton>}
          {(this.state.isEditingAddress) && <PrettyButton onClick={e => {this.handleSaveAddress(e)}}>Save</PrettyButton>}
        </InformationItem>
        }
        {(!address) &&
        <TipsBox>
          <InformationItem>
            Provide your <b>address</b> for rewards:
          </InformationItem>
            <SessionTextArea 
              style = { {height: '50px'} }
              placeholder = {address}
              disabled = {!this.state.isEditingAddress}
              onChange={(event) => {this.setState({ address: event.target.value })}}
            />
            {(!this.state.isEditingAddress) && <PrettyButton onClick={() => {this.setState({ isEditingAddress: true })}}>Edit</PrettyButton>}
            {(this.state.isEditingAddress) && <PrettyButton onClick={e => {this.handleSaveAddress(e)}}>Save</PrettyButton>}
        </TipsBox>
        }
      </FlexGrowBox>
    )
  }

  renderPaymentInformation(user, actorSpec, slackSpec) {
    return (
      <FlexGrowBox>
        <ProfileHeader>Payment Information</ProfileHeader>
        {(!this.state.isPaypalAuthenticated) && 
          <TipsBox>
            <InformationItem>Please connect Paypal with your Google account email:</InformationItem>
            <PayPalButton onClick={this.handleClickPaypalButton}>
              {PaypalIcon} 
              <Pay>Pay</Pay><Pal>Pal</Pal>
            </PayPalButton>
          </TipsBox>
        }
        {(this.state.isPaypalAuthenticated) && 
          <div>
            <InformationItem>Thank you. Your PayPal account has been connected and verified.</InformationItem>
            {!!(user.is_paused) && 
              <div>
              <InformationItem style={{ color: '#FF0000'}}>Your account has been paused because you have reached the annual tax limit allowable for gig work. Please return in the next calendar year!</InformationItem>
              </div>
            }
            <BigFigure>${user['pay_ytd'].toFixed(2)}</BigFigure>
            <InformationItem>Year to Date</InformationItem>
            <BigFigure>${actorSpec['next_pay'].toFixed(2)}</BigFigure>
            <InformationItem>Upcoming Actor Payout</InformationItem>
            <BigFigure>${slackSpec['next_pay'].toFixed(2)}</BigFigure>
            <InformationItem>Upcoming Slack Payout</InformationItem>
          </div>
        }
      </FlexGrowBox>
    )
  }

  renderActorPerformance(actorSpec) {
    const currTier = actorSpec['tier'];
    const currTotalAccept = actorSpec['total_accept'];
    const accentColor = borderColors[currTier];
    return (
      <FlexGrowBox>
        <ProfileHeader style={{ textAlign: 'center' }}>Actor Tasks</ProfileHeader>
        <InformationItem style={{ textAlign: 'center' }}>Call Center Role Play</InformationItem>
        <InformationItem style={{ textAlign: 'center' }}>{this.renderBadge(currTier)}</InformationItem>
        {currTier == 'Provisional' && <div>{this.renderProvisionalActorPerformance()}</div>}
        {(currTier !== 'Provisional' && currTier !== 'Rejected') && this.renderProgress(currTier, currTotalAccept, 'actor')}
        {(currTier !== 'Provisional' && currTier !== 'Rejected') && 
          <ProfileButton href="last_session_summary/" accentColor={accentColor}>Last Session Summary</ProfileButton>
        }
        {(currTier !== 'Provisional' && currTier !== 'Rejected') && 
          <ProfileButton href="leaderboard/actor" accentColor={accentColor}>Actor Tasks Leaderboard</ProfileButton>
        }
      </FlexGrowBox>
    )
  }

  renderSlackPerformance(slackSpec) {
    const currTier = slackSpec['tier'];
    const currTotalAccept = slackSpec['total_accept'];
    const accentColor = borderColors[currTier];
    return (
      <FlexGrowBox>
        <ProfileHeader style={{ textAlign: 'center' }}>Slack Tasks</ProfileHeader>
        <InformationItem style={{ textAlign: 'center' }}>Data Labeling</InformationItem>
        <InformationItem style={{ textAlign: 'center' }}>{this.renderBadge(currTier)}</InformationItem>
        {currTier == 'Provisional' && <div>{this.renderProvisionalSlackPerformance()}</div>}
        {(currTier !== 'Provisional' && currTier !== 'Rejected') && this.renderProgress(currTier, currTotalAccept, 'slack')}
        {(currTier !== 'Provisional' && currTier !== 'Rejected') && 
          <ProfileButton href="leaderboard/slack" accentColor={accentColor}>Slack Tasks Leaderboard</ProfileButton>
        }
      </FlexGrowBox>
    )
  }

  render() {
    const { user: user } = this.state;
    const actorSpec = user['actor_spec'];
    const slackSpec = user['slack_spec'];
    const actorTier = actorSpec['tier'];
    const slackTier = slackSpec['tier'];
    const actorBorderColor = borderColors[actorTier];
    const slackBorderColor = borderColors[slackTier];
    return (
      <PageWrapper isAdmin={this.props.isAdmin}>
        <ProfileWrapper>
          <ColumnProfileWrapper >
            {this.renderBasicInformation(user)}
            {this.renderPaymentInformation(user, actorSpec, slackSpec)}
          </ColumnProfileWrapper>
          <ColumnProfileWrapper style={{border: `2px solid ${actorBorderColor}`, borderRadius: '10px'}}>
            {this.renderActorPerformance(actorSpec)}
          </ColumnProfileWrapper>
          <ColumnProfileWrapper style={{border: `2px solid ${slackBorderColor}`, borderRadius: '10px'}}>
            {this.renderSlackPerformance(slackSpec)}
          </ColumnProfileWrapper>
        </ProfileWrapper>
      </PageWrapper>
    );
  }
}

export default ProfileScreen;
